// extracted by mini-css-extract-plugin
export default {"content":"InfoList_content__GPJzT","icon":"InfoList_icon__IY9Qp","item":"InfoList_item__YPKY7"};